import queryString from 'query-string';
/**
 * Create an image URL for ImageProcessor
 * @param image The image model
 * @param imageParams The image parameters
 * @returns The image URL
 */
export function imageUrl(image, imageParams) {
    if (!image) {
        return '';
    }
    const params = {
        rxy: image.focalPoint ? `${image.focalPoint.left},${image.focalPoint.top}` : undefined,
        ...imageParams,
    };
    if (params.width && params.heightratio) {
        params.height = Math.round(params.width / params.heightratio);
    }
    if (params.height && params.widthratio) {
        params.width = Math.round(params.height / params.widthratio);
    }
    const paramsString = queryString.stringify(params);
    return `${image.src}${paramsString ? `?${paramsString}` : ''}`;
}
export function getSrcs(image, upper, lower, steps, ratio) {
    if (!image) {
        return { src: '', srcSet: '' };
    }
    const sizes = getRange(upper, lower, steps);
    const sizesArr = sizes.map((size) => `${imageUrl(image, { width: size, heightratio: ratio })} ${size}w`);
    return {
        src: sizesArr[0].split(' ')[0],
        srcSet: sizesArr.join(','),
    };
}
export function getRetinaSrcs(image, width, ratio) {
    const dprs = [1, 1.5, 2, 2.5, 3];
    const dprsArr = dprs.map((dpr) => `${imageUrl(image, { width: width * dpr, heightratio: ratio })} ${dpr}x`);
    return {
        src: dprsArr[0].split(' ')[0],
        srcSet: dprsArr.join(','),
    };
}
function getRange(upper, lower, steps) {
    const difference = upper - lower;
    const increment = difference / (steps - 1);
    return [
        lower,
        ...Array(steps - 2)
            .fill('')
            .map((_, index) => Math.ceil(lower + increment * (index + 1))),
        upper,
    ];
}
